webpackJsonp([75313027571058],{

/***/ 406:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"postBySlug": {
				"html": "<h3 id=\"dmgt-encourages-employees-to-report-behaviour-they-see-that-is-in-breach-of-the-green-book-the-code-of-conduct-or-any-other-illegal-or-unethical-behaviour-in-the--first-instance-employees-should-be-encouraged-to-report-concerns-to-their-line-manager\"><a href=\"#dmgt-encourages-employees-to-report-behaviour-they-see-that-is-in-breach-of-the-green-book-the-code-of-conduct-or-any-other-illegal-or-unethical-behaviour-in-the--first-instance-employees-should-be-encouraged-to-report-concerns-to-their-line-manager\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>DMGT encourages employees to report behaviour they see that is in breach of the Green Book, the Code of Conduct, or any other illegal or unethical behaviour. In the  first instance, employees should be encouraged to report concerns to their line manager.</h3>\n<h4 id=\"where-for-specific-reasons-employees-feel-they-cannot-raise-the-matter-directly-with-someone-within-the-business-or-that-they-need-to-remain-anonymous-the-group-has-an-independent-speak-up-facility-this-condential-facility-is-run-by-an-impartial-third-party\"><a href=\"#where-for-specific-reasons-employees-feel-they-cannot-raise-the-matter-directly-with-someone-within-the-business-or-that-they-need-to-remain-anonymous-the-group-has-an-independent-speak-up-facility-this-condential-facility-is-run-by-an-impartial-third-party\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Where, for specific reasons, employees feel they cannot raise the matter directly with someone within the business, or that they need to remain anonymous, the Group has an independent Speak-Up facility. This condential facility is run by an impartial third party.</h4>\n<p><font color=\"green\"><H2>Key operating principles</h2></font></p>\n<ul>\n<li>\n<p>All Operating Company CEOs and CFOs have a responsibility for maintaining an environment which encourages their employees to be open with issues and speak up if they have concerns.</p>\n</li>\n<li>\n<p>Where Operating Companies are involved in a Speak-Up investigation following a report made through the Speak-Up facility, it must be conducted in accordance with the policy and the following principles:</p>\n</li>\n</ul>\n<p>++ Treat reports confidentially</p>\n<p>++ Protect the identity of the whistleblower, if known</p>\n<p>++ Respect for the individual accused in the report</p>\n<p>++ Timely and regular communication with DMGT</p>\n<ul>\n<li>Operating Companies must inform DMGT when an investigation into a Speak-Up report made through the Speak-Up facility has concluded.</li>\n</ul>\n<p><font color=\"green\"><H2>Actions</h2></font></p>\n<ul>\n<li>\n<p>All Operating Companies are required to actively promote the independent Speak-Up facility to employees and ensure the policy is accessible. Posters to promote awareness of the facility\nare available\n<a href=\"https://www.iworkhere.dmgt.com/member/login?destination=node/39%253Fpolicy_type%253D62%22Title%22\">here</a></p>\n</li>\n<li>\n<p>It is expected that Speak-Up reports are investigated and resolved within the Operating Company to which they relate. When such reports are received through the Speak-Up facility, they are visible only to the DMGT Risk Department. DMGT will in the first instance inform the Operating Company CEO, CFO, Head of HR or Legal contact, whomever is the most appropriate.</p>\n</li>\n</ul>\n<p><font color=\"green\"><H2>Interactions with DMGT</h2></font></p>\n<ul>\n<li>\n<p>DMGT will liaise with the relevant Operating Company when reports are received through the Speak-Up facility.</p>\n</li>\n<li>\n<p>Only DMGT Risk can communicate with the whistleblower in the Speak-Up facility. Any messages will be agreed with the relevant Operating Company prior to posting. </p>\n</li>\n</ul>\n<hr>\n<p><font color=\"green\"><H3>Contacts:</h3></font>\nAnnie Edwards, Global Head of HR (<a href=\"mailto:annie.edwards@dmgt.com\">annie.edwards@dmgt.com</a>)\n<br>\nCatherine Lye, Senior Risk Manager (<a href=\"mailto:catherine.lye@dmgt.com\">catherine.lye@dmgt.com</a>)</p>",
				"timeToRead": 2,
				"excerpt": "DMGT encourages employees to report behaviour they see that is in breach of the Green Book, the Code of Conduct, or any other illegal or...",
				"frontmatter": {
					"title": "Lesson Four",
					"cover": null,
					"date": null,
					"category": null,
					"tags": null
				}
			},
			"tableOfContents": {
				"chapters": [
					{
						"title": "1. Main Chapter",
						"entries": null,
						"chapters": [
							{
								"title": "1.1 Subchapter",
								"entries": [
									{
										"entry": {
											"id": "/opt/build/repo/content/lessons/lesson_one.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/1-dmgt-at-a-glance"
												},
												"frontmatter": {
													"title": "1. DMGT at a glance "
												}
											}
										}
									}
								],
								"chapters": [
									{
										"title": "1.1.1 Sub-subchapter",
										"entries": [
											{
												"entry": {
													"id": "/opt/build/repo/content/lessons/lesson_two.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/lesson-two-scope-and-responsibilities"
														},
														"frontmatter": {
															"title": "Lesson Two - Scope and responsibilities"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/opt/build/repo/content/lessons/lesson_three.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/lesson-three-code-of-conduct"
														},
														"frontmatter": {
															"title": "Lesson Three - Code of Conduct"
														}
													}
												}
											}
										]
									}
								]
							},
							{
								"title": "1.2 Subchapter",
								"entries": [
									{
										"entry": {
											"id": "/opt/build/repo/content/lessons/lesson_four.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/lesson-four"
												},
												"frontmatter": {
													"title": "Lesson Four"
												}
											}
										}
									}
								],
								"chapters": null
							}
						]
					},
					{
						"title": "2. Main Chapter",
						"entries": null,
						"chapters": [
							{
								"title": "2.1 Subchapter",
								"entries": [
									{
										"entry": {
											"id": "/opt/build/repo/content/lessons/lesson_five.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/lesson-five"
												},
												"frontmatter": {
													"title": "Lesson Five"
												}
											}
										}
									}
								],
								"chapters": null
							}
						]
					},
					{
						"title": "3. Main Chapter",
						"entries": [
							{
								"entry": {
									"id": "/opt/build/repo/content/lessons/lesson_six.md absPath of file",
									"childMarkdownRemark": {
										"fields": {
											"slug": "/lesson-six"
										},
										"frontmatter": {
											"title": "Lesson Six"
										}
									}
								}
							}
						],
						"chapters": null
					}
				]
			}
		},
		"pathContext": {
			"slug": "/lesson-four"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---lesson-four-042b61ff1383e52925de.js